var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpportunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 0.3C19.3 -0.1 18.7 -0.1 18.3 0.3L12 6.6L7.7 2.3C7.5 2.1 7.3 2 7 2C6.7 2 6.5 2.1 6.3 2.3L0.3 8.3C0.0999999 8.5 0 8.7 0 9C0 9.6 0.4 10 1 10C1.3 10 1.5 9.9 1.7 9.7L7 4.4L11.3 8.7C11.4 8.8 11.5 8.9 11.6 8.9C11.7 9 11.9 9 12 9C12.2 9 12.5 8.9 12.6 8.7C12.6 8.7 12.6 8.7 12.7 8.7L19.7 1.7C20.1 1.3 20.1 0.7 19.7 0.3Z",
    fill: "#B9B4CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunities);
export default __webpack_public_path__ + "static/media/Opportunities.4e65cf2046b8c432a9be5c6b70b94c1c.svg";
export { ForwardRef as ReactComponent };